var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemBreakdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vittles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vittles-12b",
    transform: "translate(-1232.000000, -1780.000000)",
    fill: "#40AE29",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1006.000000, 1731.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(10.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(216.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2 L0,11.8113385 L2.27272717,14 L3.63636354,12.6868064 L5,14 L6.36363646,12.6868064 L7.72727283,14 L10,11.8113385 L10,2 L0,2 Z M0.9090908,2.87546789 L9.0909092,2.87546789 L9.0909092,11.4488392 L7.72727283,12.7620328 L6.36363646,11.4488392 L4.99999991,12.7620328 L3.63636354,11.4488392 L2.27272717,12.7620328 L0.9090908,11.4488392 L0.9090908,2.87546789 Z M1.81818177,4.62638713 L1.81818177,5.50185502 L6.36363646,5.50185502 L6.36363646,4.62638713 L1.81818177,4.62638713 Z M7.27272726,4.62638713 L7.27272726,5.50185502 L8.18181823,5.50185502 L8.18181823,4.62638713 L7.27272726,4.62638713 Z M1.81818177,6.81504858 L1.81818177,7.69049992 L6.36363646,7.69049992 L6.36363646,6.81504858 L1.81818177,6.81504858 Z M7.27272726,6.81504858 L7.27272726,7.69049992 L8.18181823,7.69049992 L8.18181823,6.81504858 L7.27272726,6.81504858 Z M1.81818177,9.00369349 L1.81818177,9.87916138 L6.36363646,9.87916138 L6.36363646,9.00369349 L1.81818177,9.00369349 Z M7.27272726,9.00369349 L7.27272726,9.87916138 L8.18181823,9.87916138 L8.18181823,9.00369349 L7.27272726,9.00369349 Z",
    id: "Shape"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemBreakdown);
export default __webpack_public_path__ + "static/media/item-breakdown.ddeb7324733fa710fc28110a54ff33a4.svg";
export { ForwardRef as ReactComponent };